$(function(){
	$('a[href*=\\#]:not([href=\\#])').on('click',function() {
	if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
			var $target = $(this.hash);
			$target = $target.length && $target || $('[name=' + this.hash.slice(1) +']');
			if ($target.length) {
				if($(this).parents('.menuBox').length){
					setTimeout(function(){
						var targetOffset = $target.offset().top - $('#gHeader').innerHeight();
						$('html,body').animate({scrollTop: targetOffset}, 1000);
					},100);
				}else{
					var targetOffset = $target.offset().top - $('#gHeader').innerHeight();
					$('html,body').animate({scrollTop: targetOffset}, 1000);
				}
				return false;
			}
		}
	});

	var state = false;
	var scrollpos;
	var state02 = false;
	var scrollpos02;

	$('.menu').on('click', function(){
		if(state == false) {
			scrollpos = $(window).scrollTop();
			$('body').addClass('fixed').css({'top': -scrollpos});
			$(this).addClass('on');
			$('.menuBox').stop().fadeToggle();
			state = true;
			if(state02) {
				state02 = false;
				$('.cover,.searchBox').fadeOut();
			}
		}else{
			$('body').removeClass('fixed').css({'top': 0});
			window.scrollTo( 0 , scrollpos );
			$(this).removeClass('on');
			$('.menuBox').stop().fadeToggle();
			state = false;
		}
		return false;
	});


	if(window.innerWidth < 897){
		$('#gHeader .searchBtn').on('click', function(){
			if(state02 == false) {
				scrollpos02 = $(window).scrollTop();
				$('body').addClass('fixed').css({'top': -scrollpos02});
				$('.cover').stop().fadeToggle();
				$('.searchBox').stop().fadeToggle();
				state02 = true;
				if(state) {
					state = false;
					$('.menuBox').fadeOut();
					$('.menu').removeClass('on');
				}
			}else{
				$('body').removeClass('fixed').css({'top': 0});
				window.scrollTo( 0 , scrollpos02 );
				$('.cover').stop().fadeToggle();
				$('.searchBox').stop().fadeToggle();
				state02 = false;
			}
			return false;
		});

		$('.cover,.searchBox .closeBtn').on('click',function(){
			$('body').removeClass('fixed').css({'top': 0});
			window.scrollTo( 0 , scrollpos02 );
			$('.cover').stop().fadeToggle();
			$('.searchBox').stop().fadeToggle();
			state02 = false;
		});
	}


	$(".comListDl dt").click(function(){
		$(this).toggleClass("on");
		$(this).next("dd").stop().slideToggle(300);
		return false;
	});
});

$(window).on('load',function(){
	var localLink = window.location+'';
	if(localLink.indexOf("#") != -1 && localLink.slice(-1) != '#'){
		localLink = localLink.slice(localLink.indexOf("#")+1);
		if($('#'+localLink).length){
			setTimeout(function(){
				$('html,body').animate({scrollTop: $('#'+localLink).offset().top - $('#gHeader').innerHeight()}, 500);
			},100);
		}
	}
});